import React from "react";
var __jsx = React.createElement;
var PriceOfferDesktopLayout = function PriceOfferDesktopLayout(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "md:bg-[#F4F7FB] md:pt-[72px] md:min-h-[calc(100vh-120px)]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "px-4 py-6 min-h-[calc(100vh-72px)] relative md:bg-white md:mx-auto md:max-w-[640px] md:rounded-2xl md:min-h-[unset] md:p-8"
  }, children)));
};
export default PriceOfferDesktopLayout;